'use strict';

import React from 'react';
import StampActionCreators from '../actions/StampActionCreators';
import ClassNameMixin from '../mixins/ClassNameMixin';
import createStoreMixin from '../mixins/createStoreMixin';
import UserStore from '../stores/UserStore';
import PureRenderMixin from '../mixins/PureRenderMixin';
import UserLink from '../atoms/UserLink';
import UserImage from '../atoms/UserImage';
import Button from '../atoms/Button';
import Counter from '../atoms/Counter';
import Icon from '../atoms/Icon';
import SidebarActionCreators from '../actions/SidebarActionCreators';
import SidebarTypes from '../constants/SidebarTypes';
import { PropTypes } from 'react';
import getStampSegment from '../utils/getStampSegment';

import './LikeButton.less';

var LIKE_COUNT = 3;

var LikeButton = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin, createStoreMixin(UserStore)],

  propTypes: {
    size: PropTypes.oneOf(['large', 'xlarge']),
    iconSize: React.PropTypes.oneOf(['xxsmall', 'xsmall', 'small', 'medium', 'large']),
    fill: PropTypes.bool,
    stamp: PropTypes.object.isRequired,
    showLikers: PropTypes.bool,
    showCounter: PropTypes.bool
  },

  getDefaultProps() {
    return {
      iconSize: 'small'
    };
  },

  getCSSModifiers() {
    return [this.props.size];
  },

  getStateFromStores(props) {
    var state = {};
    if (props.showLikers) {
      state.likers = props.stamp.likes.map(UserStore.get);
    }

    return state;
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.stamp !== this.props.stamp) {
      this.setState(this.getStateFromStores(nextProps));
    }
  },

  render() {
    var stamp = this.props.stamp;

    return (
      <div className={this.getClassName()}>
        <Button size={this.props.size}
                color={this.props.color}
                onClick={this.handleLikeClick}
                active={stamp.isLiked}
                overlay={this.props.overlay}
                fill={this.props.fill}
                context={this.props.context}
                round
                like>
          <Icon name='like'
                mode='fill'
                context='LikeButton'
                size={this.props.iconSize}/>
        </Button>

        {this.props.showCounter && stamp.likeCount > 0 &&
          <Counter count={stamp.likeCount}
                   onClick={this.handleShowMoreClick}
                   context='LikeButton' />
        }

        {this.props.showLikers &&
          <ul className='LikeButton-likers'>
            {this.renderLikers()}
          </ul>
        }
      </div>
    );
  },

  renderLikers() {
    var needShowMore = this.state.likers.length > LIKE_COUNT,
        likers;

    likers = this.state.likers.slice(0, LIKE_COUNT).map(liker => {
      return (
        <li key={liker.id}>
          <UserLink user={liker} showTitle>
            <UserImage user={liker}
                       size='small'/>
          </UserLink>
        </li>
      );
    });

    if (needShowMore) {
      likers.push(
        <li key='more'>
          <Button size='small'
                  color='gray'
                  round
                  onClick={this.handleShowMoreClick}>
            <Icon name='more' size='small' />
          </Button>
        </li>
      );
    }

    return likers;
  },

  handleShowMoreClick() {
    SidebarActionCreators.showSidebar(SidebarTypes.STAMP_LIKES, {
      stampId: this.props.stamp.id
    });
  },

  handleLikeClick() {
    const { stamp } = this.props;
    const stampSegment = getStampSegment(stamp);

    if (stamp.isLiked) {
      StampActionCreators.unlikeStamp(stampSegment);
    } else {
      StampActionCreators.likeStamp(stampSegment);
    }
  }
});

export default LikeButton;


/** WEBPACK FOOTER **
 ** ./molecules/LikeButton.jsx
 **/